import { render, staticRenderFns } from "./imTinggo.vue?vue&type=template&id=17f0da87&scoped=true"
import script from "./imTinggo.vue?vue&type=script&lang=js"
export * from "./imTinggo.vue?vue&type=script&lang=js"
import style0 from "./imTinggo.vue?vue&type=style&index=0&id=17f0da87&prod&lang=less&scoped=true"
import style1 from "./imTinggo.vue?vue&type=style&index=1&id=17f0da87&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17f0da87",
  null
  
)

export default component.exports